import { Routes, Route } from "react-router-dom";
import ProtectedLayout from "./components/ProtectedLayout";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import Pacientes from "./pages/Pacientes";
import Parceiros from "./pages/Parceiros";
import Social from "./pages/Social";
import Reports from "./pages/Reports";
import Profile from "./pages/Profile";
import Info from "./pages/Info";
import About from "./pages/About";


import PacientesDash from "./pages/Pacientes/PacientesDash";
import PacientesSocial from "./pages/Pacientes/PacientesSocial";
import PacientesInfo from "./pages/Pacientes/PacientesInfo";
import PacientesHistorico from "./pages/Pacientes/PacientesHistorico";    
import PacientesServicos from "./pages/Pacientes/PacientesServicos";
import ProtectedLayoutPaciente from "./components/ProtectedLayoutPaciente";
import { NotificationProvider } from "./components/NotificationContext";
import "./App.css"; // Importa o novo CSS

function App() {
  return (
    <NotificationProvider>
      <Routes>
        {/* Rotas SEM Sidebar */}
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        

        {/* Rotas para pacientes */}
        <Route element={<ProtectedLayoutPaciente />}>
          <Route path="/dashpacientes" element={<PacientesDash />} />
          <Route path="/infopaciente" element={<PacientesInfo />} />
          <Route path="/socialpaciente" element={<PacientesSocial />} />
          <Route path="/historicopaciente" element={<PacientesHistorico />} />
          <Route path="/servicospaciente" element={<PacientesServicos />} />
          <Route path="/aboutpaciente" element={<About />} />
        </Route>
        {/* Rotas para usuários comuns */}
        <Route element={<ProtectedLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/pacientes" element={<Pacientes />} />
          <Route path="/parceiros" element={<Parceiros />} />
          <Route path="/social" element={<Social />} />
          <Route path="/relatorios" element={<Reports />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/info" element={<Info />} />
          <Route path="/about" element={<About />} />
        </Route>
      </Routes>
    </NotificationProvider>
  );
}

export default App;
